var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlpineskiing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m24.855 4.79 6.78.63 3.458 2.418-.07.393-.062.405c-.51 3.767.755 7.216 8.918 9.43l-.972 1.416-1.34.495-4.311-.495-4.18-2.474-1.314-2.352 1.741-3.036-10.938-6.256 2.29-.573Zm-5.806 1.457.943-.237 11 6.292-.548.953-11.395-7.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#040404",
    d: "m32.589 13.215.91-1.59 0-.026c.148 3.715 3.284 6.343 9.408 7.883l-1.34.495-4.311-.495-4.18-2.474-1.314-2.352.827-1.441Zm-6.498-2.44c.776.037 1.703.136 2.679.255l2.222 1.272-.562.977-4.339-2.504Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m0 16.787 1.394-2.311 28.621 16.882c3.161 1.865 6.891 2.509 10.487 1.82l.431-.089.627 2.625c-4.468 1.063-9.174.344-13.12-2.003l-28.44-16.924Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "15.253 8.987 16.704 7.569 29.489 14.881 29.658 15.138 28.569 17.165 21.698 21.124 23.855 23.262 22.681 24.907 14.35 19.946 22.369 15.381 16.011 11.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "26.128 16.247 25.872 12.813 29.489 14.881 29.658 15.138 28.569 17.165 21.698 21.124 23.855 23.262 22.681 24.907 16.857 21.44",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "41.397 5.934 45.261 8.162 46.431 10.952 43.248 13.132 41.397 14.86 38.014 13.132 36.755 10.763 37.533 8.162"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "39.956 6.778 41.766 5.63 44.1 6.026 46.431 8.691 46.431 10.952 43.844 12.853"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "46.437 8.678 46.431 10.952 43.872 12.836 42.533 10.784",
    opacity: 0.297
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "9.483 0 9.981 .285 30.494 12.017 30.992 12.302 30.421 13.297 29.923 13.012 9.411 1.28 8.913 .995"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    fillRule: "nonzero",
    points: "45.005 19.458 45.514 19.723 49.491 21.801 50 22.066 49.468 23.083 48.959 22.817 44.981 20.74 44.473 20.474"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#282828",
    points: "40.839 11.816 42.639 10.693 44.071 12.981 42.271 14.104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#282828",
    points: "39.214 7.105 40.071 6.57 42.683 10.745 41.826 11.279"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpineskiing);
export default __webpack_public_path__ + "static/media/alpineskiing.d7d11508c6dccdc3d5b52e2468d5dede.svg";
export { ForwardRef as ReactComponent };